import { LayerProps } from 'react-map-gl';

const dataLayer: LayerProps = {
  id: 'lieuucation-outline',
  type: 'line',
  source: 'lieuucations',
  ...{ 'source-layer': 'lieuucations' },
  beforeId: 'road-label',
  layout: {
    'line-cap': 'round',
    'line-join': 'round'
  },
  paint: {
    'line-dasharray': [
      'step',
      ['zoom'],
      ['literal', [2, 0]],
      7,
      ['literal', [2, 6, 6, 2]]
    ],
    'line-width': ['interpolate', ['linear'], ['zoom'], 7, 0.5, 12, 1.25],
    'line-opacity': ['interpolate', ['linear'], ['zoom'], 7, 0.2, 12, 0.35],
    'line-color': '#ffffff'
  }
};

export default dataLayer;
